export default __webpack_public_path__ + "static/media/ic_rate_yellow_star.9246b06539ee2eaea4bc9043e0a498ac.svg";